module.exports = __webpack_public_path__ + "img/7.9fd0ce44.jpg";